import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationModalComponent } from '../../../shared/confirmation-modal/confirmation-modal.component';

@Injectable({
  providedIn: 'root',
})
export class confirmService {
  constructor(private modalService: NgbModal) {}

  openConfirmationModal(
    title: string,
    message: string,
    confirmButtonText: string = 'Valider',
    cancelButtonText: string = 'Annuler',
    centered: boolean = true
  ): Promise<boolean> {
    const modalRef = this.modalService.open(ConfirmationModalComponent, {
      centered: centered,
    });
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.confirmButtonText = confirmButtonText;
    modalRef.componentInstance.cancelButtonText = cancelButtonText;

    return modalRef.result.catch(() => false); // Retourne `false` en cas de fermeture par la croix ou annulation
  }
}
